// extracted by mini-css-extract-plugin
export var searchHeader = "_8o-0";
export var searchHeaderDark = "_8o-1";